import styled, { createGlobalStyle } from 'styled-components'

/* =======================
   CONTAINER GERAL
======================= */
export const FichaContainer = styled.div`
width: 100%;
  padding: 20px;
  background: #f0f2f5;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 8px;
  }
`

/* =======================
   SELETOR DE ANO
======================= */
export const YearSelectorWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    gap: 8px;
  }
`

export const YearSelectorLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: var(--text, var(--text-muted));
`

export const YearSelect = styled.select`
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--line);
  font-size: 14px;
  background: var(--surface);
  cursor: pointer;
  min-width: 200px;
`

export const PrintButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background: #1976d2;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #1565c0;
  }
`

/* =======================
   FOLHA (FICHA)
======================= */
export const FichaWrapper = styled.div`
  background: var(--surface);
  width: 100%;
  max-width: 870px;
  margin: 0 auto;
  padding: 18px 20px;
  box-sizing: border-box;
  border: 1px solid var(--line);
  font-family: Arial, sans-serif;
  color: var(--text, var(--text-muted));

  @media (max-width: 768px) {
    padding: 10px 8px;
  }
`

/* =======================
   CABEÇALHO
======================= */
export const FichaHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #000;
  padding: 6px 10px;
  margin-bottom: 4px;
`

export const Brasao = styled.div`
  font-size: 36px;
  line-height: 1;

  /* fica à esquerda sem deslocar o texto central */
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);

  /* quando renderizado como <img> via prop "as" (logo da escola) */
  &[src] {
    width: 70px;
    height: 70px;
    object-fit: contain;
  }

  @media print {
    font-size: 30px;
    left: 8px;

    &[src] {
      width: 58px;
      height: 58px;
    }
  }
`

export const FichaNomeEscola = styled.div`
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 2px;
  color: var(--text, var(--text-muted));

  @media print {
    font-size: 11px;
  }
`

export const HeaderCenter = styled.div`
  text-align: center;
  width: 100%;
  /* espaço lateral para o texto não sobrepor a logo em telas estreitas */
  padding: 0 80px;
  box-sizing: border-box;

  @media print {
    padding: 0 66px;
  }

  @media (max-width: 480px) {
    padding: 0 70px;
  }
`

export const FichaPrefeitura = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media print {
    font-size: 12px;
  }
`

export const FichaSecretaria = styled.div`
  font-size: 12px;
  font-style: italic;

  @media print {
    font-size: 11px;
  }
`

/* =======================
   TÍTULO E MUNICÍPIO
======================= */
export const FichaTitleBox = styled.div`
  border: 2px solid #000;
  border-top: none;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  padding: 4px 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;

  @media print {
    font-size: 12px;
    padding: 2px 4px;
  }
`

export const FichaMunicipioBox = styled.div`
  border: 2px solid #000;
  border-top: none;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  padding: 4px 6px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media print {
    font-size: 12px;
    padding: 3px 4px;
    margin-bottom: 4px;
  }
`

/* =======================
   CAMPOS DO FORMULÁRIO
======================= */
export const FieldRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 6px;
  flex-wrap: wrap;

  @media print {
    margin-bottom: 3px;
  }
`

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${({ flex }) => flex || 'none'};
  width: ${({ width }) => width || 'auto'};
  min-width: ${({ width }) => width || '0'};
`

export const FieldLabel = styled.span`
  font-size: 11px;
  color: var(--text, var(--text-muted));
  white-space: nowrap;

  @media print {
    font-size: 10px;
  }
`

export const FieldUnderline = styled.div`
  border-bottom: 1px solid #000;
  min-height: 18px;
  font-size: 12px;
  font-weight: 600;
  padding: 1px 2px;
  color: var(--text, var(--text-muted));

  @media print {
    font-size: 10px;
    min-height: 14px;
  }
`

/* =======================
   SCROLL DA TABELA
======================= */
export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 10px;

  @media print {
    overflow: visible;
    margin-top: 4px;
  }
`

/* =======================
   TABELA PRINCIPAL
======================= */
export const FichaTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 10px;
  color: var(--text, var(--text-muted));

  /* ---- CÉLULAS BASE ---- */
  th,
  td {
    border: 1px solid #000;
    padding: 0px 0px;
    text-align: center;
    vertical-align: middle;
    word-break: break-word;
  }

  /* ---- TRIMESTRE (coluna rotacionada) ---- */
  .th-trimestre {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 11px;
    font-weight: bold;
    width: 38px;
    min-width: 38px;
    max-width: 38px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  /* ---- VERIFICAÇÃO DO RENDIMENTO ---- */
  .th-verif {
    font-size: 11px;
    font-weight: bold;
    width: 70px;
    min-width: 70px;
    text-align: center;
    text-transform: uppercase;
    line-height: 1.4;
  }

  /* ---- GRUPOS DE CABEÇALHO ---- */
  .th-group {
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    background: var(--surface);
    letter-spacing: 0.3px;
  }

  /* ---- MATÉRIAS (header rotacionado) ---- */
  .th-subject {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
    min-height: 80px;
    height: auto;
    width: auto;
    min-width: 36px;
    padding: 6px 4px;
    text-transform: uppercase;
  }

  /* ---- PARTE DIVERSIFICADA ---- */
  .th-parte-div {
    font-size: 8px;
    font-weight: bold;
    text-transform: uppercase;
    width: 48px;
    min-width: 48px;
    line-height: 1.3;
  }

  /* ---- SITUAÇÃO DO ALUNO ---- */
  .th-situacao {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 11px;
    font-weight: bold;
    width: 28px;
    min-width: 36px;
    max-width: 36px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /* ---- OBSERVAÇÕES ---- */
  .th-obs {
    font-size: 9px;
    font-weight: bold;
    text-transform: uppercase;
    width: 120px;
    min-width: 120px;
  }

  /* ---- CÉLULA DE PERÍODO (1º, 2º, etc.) ---- */
  .td-periodo {
    font-size: 11px;
    font-weight: bold;
    width: 38px;
    min-width: 38px;
    max-width: 38px;
    text-align: center;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    letter-spacing: 1px;
  }

  /* ---- TOTAL / RECUPERAÇÃO ---- */
  .td-total-label {
    font-size: 10px;
    font-weight: bold;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1.2;
    width: 38px;
    min-width: 38px;
    max-width: 38px;
  }

  /* ---- RÓTULO DA LINHA (Aproveitamento, Carga, Faltas) ---- */
  .td-row-label {
    font-size: 11px;
    text-align: left;
    padding-left: 4px;
    white-space: nowrap;
    width: 70px;
    min-width: 70px;
    font-weight: 500;
  }

  /* ---- CÉLULA DE NOTA ---- */
  .td-grade {
    font-size: 11px;
    font-weight: 600;
    width: auto;
    min-width: 36px;
    height: 18px;
  }
  
  .td-merged-value {
    font-size: 11px;
    font-weight: 600;
    width: auto;
    min-width: 36px;
    height: 18px;
  }

  /* ---- SITUAÇÃO CÉLULA (dado) ---- */
  .td-situacao-cell {
    font-size: 11px;
    font-weight: bold;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-transform: uppercase;
    width: 28px;
    min-width: 28px;
    max-width: 28px;
    text-align: center;
    letter-spacing: 0.3px;
  }

  /* ---- OBSERVAÇÃO CÉLULA (dado) ---- */
  .td-obs-cell {
    width: 170px;
    min-width: 170px;
    vertical-align: top;
    text-align: left;
    padding: 6px 8px;
    font-size: 11px;
    line-height: 1.35;
    word-break: break-word;
    white-space: pre-wrap;
  }

  @media print {
    font-size: 8px;

    th, td {
      padding: 0px 0px;
    }

    .th-subject {
      min-height: 60px;
      height: auto;
      font-size: 9px;
      width: auto;
      min-width: 30px;
    }

    .th-trimestre,
    .td-periodo {
      font-size: 10px;
      width: 38px;
      min-width: 38px;
      max-width: 38px;
    }

    .td-total-label {
      width: 30px;
      min-width: 30px;
      max-width: 30px;
    }

    .th-verif,
    .td-row-label {
      font-size: 10px;
      width: 60px;
      min-width: 60px;
    }

    .td-grade {
      font-size: 10px;
      height: 14px;
      width: auto;
      min-width: 30px;
    }

    /* 5× a largura original de impressão (55px × 5 = 275px) */
    .th-obs {
      font-size: 10px;
    }
    .th-obs,
    .td-obs-cell {
      width: 180px;
      min-width: 180px;
    }
    .td-obs-cell {
      vertical-align: top;
      text-align: left;
      padding: 4px 5px !important;
      font-size: 8px !important;
      line-height: 1.3 !important;
      word-break: break-word;
      white-space: pre-wrap;
    }
  }
`

/* =======================
   SÍNTESE DO PROFESSOR
======================= */
export const SummaryBox = styled.div`
  margin-top: 14px;
  margin-bottom: 6px;
  border: 1px solid #000;
  padding: 6px 8px;

  @media print {
    margin-top: 8px;
    margin-bottom: 4px;
    padding: 4px 6px;
  }
`

export const SummaryLabel = styled.div`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
  color: var(--text, var(--text-muted));

  @media print {
    font-size: 12px;
    margin-bottom: 3px;
  }
`

export const SummaryText = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: var(--text, var(--text-muted));
  min-height: 48px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;

  @media print {
    font-size: 11px;
    min-height: 36px;
  }
`

/* =======================
   ASSINATURAS
======================= */
export const FichaSignatures = styled.div`
  margin-top: 24px;

  @media print {
    margin-top: 10px;
  }
`

export const SignRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 16px;
  }

  @media print {
    margin-bottom: 10px;
    gap: 20px;
  }
`

export const SignBlock = styled.div`
  flex: 1;
  text-align: center;
`

export const SignLine = styled.div`
  border-bottom: 1px solid #000;
  margin-bottom: 5px;
  height: 22px;
`

export const SignLabel = styled.span`
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 500;

  @media print {
    font-size: 7.5px;
  }
`

export const MunicipioDateRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;

  @media print {
    margin-top: 4px;
  }
`

/* =======================
   ESTILOS GLOBAIS DE IMPRESSÃO
======================= */
export const FichaGlobalPrint = createGlobalStyle`
  @media print {
    @page {
      size: A4 portrait;
      margin: 6mm;
    }

    body * {
      visibility: hidden;
    }

    /* ---- Mostra apenas a ficha ---- */
    body.print-ficha .print-ficha-content,
    body.print-ficha .print-ficha-content * {
      visibility: visible;
    }

    body.print-ficha .print-ficha-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      max-width: none;
      border: none;
      padding: 0;
      margin: 0;
    }

    /* ---- Esconde controles ---- */
    .no-print,
    button {
      display: none !important;
    }

    /* ---- Ajustes finos de impressão ---- */
    p, span, strong, label, div {
      font-size: 9px;
    }
  }
`
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  animation: overlayIn 0.2s ease;

  @keyframes overlayIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`

export const Modal = styled.div`
  background: var(--surface);
  padding: 20px;
  border-radius: 12px;
  width: 900px;
  max-width: 100%;
  max-height: 90vh;
  overflow-y: auto;
`

/* Modal dedicado à edição da ficha (layout rico, não afeta os avisos) */
export const EditModal = styled.div`
  background: var(--surface);
  border-radius: 18px;
  width: 900px;
  max-width: 100%;
  max-height: 92vh;
  overflow-y: auto;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
  animation: modalIn 0.22s ease;

  /* cabeçalho fixo */
  & > h2 {
    position: sticky;
    top: 0;
    z-index: 5;
    margin: 0;
    padding: 20px 28px;
    font-size: 20px;
    font-weight: 800;
    color: #0f2540;
    background: linear-gradient(180deg, #ffffff 0%, #f7fafd 100%);
    border-bottom: 1px solid #eef1f6;
  }

  /* espaçamento do conteúdo (tudo depois do h2) */
  & > *:not(h2) {
    margin-left: 28px;
    margin-right: 28px;
  }
  & > *:last-child {
    margin-bottom: 24px;
  }

  @keyframes modalIn {
    from { transform: translateY(12px) scale(0.98); opacity: 0; }
    to { transform: translateY(0) scale(1); opacity: 1; }
  }

  &::-webkit-scrollbar { width: 10px; }
  &::-webkit-scrollbar-thumb {
    background: #d5dce8;
    border-radius: 8px;
    border: 2px solid #ffffff;
  }

  @media (max-width: 640px) {
    border-radius: 14px;
    & > h2 { padding: 16px 18px; font-size: 18px; }
    & > *:not(h2) { margin-left: 16px; margin-right: 16px; }
  }
`
export const Section = styled.div`
  margin-top: 22px;
  margin-bottom: 22px;
  padding: 18px;
  border: 1px solid #eef1f6;
  border-radius: 14px;
  background: #fbfcfe;
`

export const SectionTitle = styled.h3`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin: 0 0 16px;
  padding-left: 12px;
  color: #1976d2;
  border-left: 4px solid #1976d2;
`
export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`
export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabelStyled = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: var(--text, var(--text-muted));
`;

export const Input = styled.input.attrs(props => ({
  type: props.type || 'text'
}))`
  width: 100%;
  box-sizing: border-box;
  padding: 11px 13px;
  border-radius: 10px;
  border: 1px solid #d7dfea;
  font-size: 14px;
  color: #0f2540;
  background: var(--surface);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.15);
  }
`;

export const Select = styled.select`
  width: 100%;
  box-sizing: border-box;
  padding: 11px 13px;
  border-radius: 10px;
  border: 1px solid #d7dfea;
  font-size: 14px;
  color: #0f2540;
  background: var(--surface);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.15);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  padding: 11px 13px;
  border-radius: 10px;
  border: 1px solid #d7dfea;
  font-size: 14px;
  color: #0f2540;
  background: var(--surface);
  min-height: 80px;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.15);
  }
`;
export const PeriodCard = styled.div`
  border: 1px solid #e4e9f2;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 14px;
  background: var(--surface);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
`

export const PeriodTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #0f2540;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e4e9f2;
`

/* Subtítulo dentro de um período (ex.: "Notas") */
export const SubLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #94a3b8;
  margin: 4px 0 8px;
`

/* Faixa destacada de frequência (faltas + dias letivos) */
export const FreqStrip = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 14px;
  padding: 14px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f5f9ff 0%, #eef4ff 100%);
  border: 1px solid #dbe7fb;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

export const FreqItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FreqLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: ${props => (props.$variant === 'faltas' ? '#c2410c' : 'var(--blue, #3b82f6)')};

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${props => (props.$variant === 'faltas' ? '#f97316' : '#3b82f6')};
  }
`

export const Actions = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding: 16px 0 4px;
  background: linear-gradient(0deg, #ffffff 70%, rgba(255,255,255,0));
`

export const Button = styled.button`
  padding: 11px 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: transform 0.08s, filter 0.15s, background 0.15s;

  background: ${props =>
    props.variant === 'primary' ? '#1976d2'
    : props.variant === 'danger' ? '#e2e8f0'
    : '#eef2f7'};
  color: ${props => props.variant === 'primary' ? 'var(--surface)' : '#334155'};

  &:hover { filter: brightness(0.97); }
  &:active { transform: translateY(1px); }
`
/* ================= AVISO DE PERÍODOS FALTANDO ================= */
export const PeriodWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 4px 0 16px;
  padding: 14px 16px;
  border: 1px solid #ffe0a3;
  border-left: 4px solid #f5a623;
  border-radius: 10px;
  background: linear-gradient(0deg, #fffaf0, #fff8e8);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
`

export const PeriodWarningIcon = styled.div`
  font-size: 22px;
  line-height: 1.2;
  flex-shrink: 0;
`

export const PeriodWarningContent = styled.div`
  flex: 1;
`

export const PeriodWarningTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #9a6a00;
  margin-bottom: 4px;
`

export const PeriodWarningText = styled.div`
  font-size: 13px;
  line-height: 1.6;
  color: #6b5424;

  strong {
    color: #7a4f00;
    font-weight: 700;
  }
`